module.exports = __webpack_public_path__ + "img/Yostar_User@2x.b60a228b.png";